import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  useHistory,
} from '../hooks'

const useCurrentAccountingBook =  (authState) => {
  const history = useHistory();
  const { group_id } = useParams();
  const [err, setErr] = useState(null);
  const [accountingBookId, setAccountingBookId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authState && authState.api) {
      let accounting_book_id;

      authState.api.getCurrentAccountingBook(group_id, accounting_book_id)
        .then((response) => {
          setAccountingBookId(response.data.id)
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
        })
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [authState])

  return [accountingBookId, loading, err];
}

export default useCurrentAccountingBook;
